


































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import ModalEdit from "@/components/ModalEdit.vue";
import { CMProfile } from "@/models/cm-profile.model";
import { CMPRofileApi } from "@/services/api.service";

@Component({
    components: {
        ModalEdit
    }
})
export default class ProfileBiography extends Vue {
    public showEditDialog: boolean = false;
    public saving: boolean = false;
    public biography: string = "";
    public titleModalEdit: string = "";

    @Prop({ type: Boolean, default: false })
    public authorRequire;

    public get profile() {
        return this.$store.getters.profile;
    }

    public handleModalClose() {
        this.showEditDialog = false;
    }

    public openModalEdit() {
        this.showEditDialog = true;
    }

    public mounted() {
        this.biography = this.profile.biography;
    }

    public async updateBio() {
        this.saving = true;
        this.profile.biography = this.biography;
        try {
            await CMPRofileApi.updateBio(this.profile.biography);
            this.$store.commit("updateProfile", this.profile);
            this.saving = false;
        } catch (e) {
            console.error(e);
            this.saving = false;
        }
        this.showEditDialog = false;
    }

    @Watch("profile", { deep: true })
    public onProfileChange(val: CMProfile, oldVal: CMProfile) {
        this.biography = this.profile.biography;
    }
}
